// @ts-check
const ASSIST = 'qp-move.assist.v1';
/** Local-only player preferences. Storage can be absent or blocked; the default then applies. */
export const preferences = {
  get assist() {
    try { return window.localStorage.getItem(ASSIST) === 'on'; } catch { return false; }
  },
  set assist(value) {
    try { window.localStorage.setItem(ASSIST, value ? 'on' : 'off'); } catch { /* The choice still holds for this visit. */ }
  },
};
